import { createSlotRecipe } from './runtime.js';

const tooltipConfig = {"name":"tooltip","slots":["root","arrow","dismiss"],"defaultVariants":{"closable":false},"variantMap":{"closable":["true"]}}

export const tooltip = /* @__PURE__ */ createSlotRecipe(tooltipConfig)